export const ONBOARDING_STEPS = [
    { id: 'project', label: 'Project actief', hint: 'Werkruimte aangemaakt', route: '/app/projects' },
    { id: 'brand_dna', label: 'Bedrijfs-DNA ingevuld', hint: 'Merkprofiel voor AI & mail', route: '/app/bedrijfs-dna' },
    { id: 'mailbox', label: 'Mailbox of Brevo', hint: 'SMTP/IMAP of Brevo transactional', route: '/app/mailboxen' },
    { id: 'template', label: 'Eerste template', hint: 'Blueprint in bibliotheek', route: '/app/campagnes/bibliotheek' },
    { id: 'sequence', label: 'Eerste sequence', hint: 'Stappen voor outreach', route: '/app/campagnes/bibliotheek' },
    { id: 'testmail', label: 'Testmail verstuurd', hint: 'Minimaal één outbound mail', route: '/app/inbox' },
];
//# sourceMappingURL=onboardingSteps.js.map